import { getGetProgramByIDQueryOptions } from "@getbread/api-client-program-v2";
import { useQueries } from "@tanstack/react-query";

import { getRequestConfig } from "merchant-portal-data/request";

export interface UseGetProgramsByIDsParams {
	programIDs: string[];
}

export const useGetProgramsByIDs = ({ programIDs }: UseGetProgramsByIDsParams) => {
	const results = useQueries({
		queries: programIDs.map((programID) => ({
			...getGetProgramByIDQueryOptions(programID, getRequestConfig()),
			enabled: programIDs.length > 0,
		})),
		combine: (r) => ({
			data: r.map((result) => result.data),
			isLoading: r.some((result) => result.isLoading),
		}),
	});

	return results;
};
